import { useQuery } from 'react-query';
import request from '../../../helpers/request';
import { getQueryKeys } from './queryKeys';

const getFlatMeters = async (addressId) => {
  return await request.get(
    `/HousingStock/address/${addressId}/meters`,
    {},
    'При загрузке счетчиков квартиры произошла ошибка',
    []
  );
};

const useFlatMeters = (addressId, options = {}) =>
  useQuery(getQueryKeys.flatMeters(addressId), () => getFlatMeters(addressId), {
    placeholderData: [],
    enabled: Boolean(addressId),
    ...options,
  });

export default useFlatMeters;
